<template>
  <div class="main">
    <!-- 分子公司 -->
    <div class="subsidiary">
      <div class="topTitle animate__animated animate__zoomIn">
        <div class="chinese">分子公司</div>
        <div class="english">SUBSIDIARY COMPANIES</div>
      </div>
      <div class="flexCenter">
        <div class="companies">
          <div class="nameList">
            <div class="item" v-for="(itemCh, index) in companies_kind" :key="'com_type' + index"
              :class="{ active: itemCh.shortName == activeCompany.shortName }" @click="onChild(itemCh)">
              <span>{{ itemCh.shortName }}</span>
            </div>
          </div>
        </div>
        <div class="map">
          <div class="mabs">
            <Bmap ref="Bmap" :list="list"></Bmap>
          </div>
          <div class="detail" data-no-translate>
            <div class="comName">
              {{ activeCompany.shortName }}
            </div>
            <div>
              <img src="@/assets/img/icon/iconLocation.png" />
              {{ activeCompany.address }}
            </div>
            <div>
              <img src="@/assets/img/icon/phone.png" />
              {{ activeCompany.tel }}
            </div>
            <div v-if="activeCompany.officialWebsite">
              <img src="@/assets/img/icon/url.png" />
              <a style="text-decoration: none" :href="activeCompany.officialWebsite" target="blank">{{
              activeCompany.officialWebsite }}</a>
            </div>
            <div class="btns">
              <img @click="backCompany" src="@/assets/img/icon/arrow_left.png" alt="">
              <img @click="nextCompany" src="@/assets/img/icon/arrow_right.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Map from "../components/Map.vue";
import Bmap from "../components/Bmap.vue"
export default {
  name: "SubCompanies",
  components: {
    Map,
    Bmap
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      companies_kind: [],
      companies_type: ["分公司", "控股子公司", "参股公司"],
      activeCompany: {},//当前公司

    };
  },
  watch: {
    list: {
      handler(val) {
        this.companies_kind = JSON.parse(JSON.stringify(val));
        this.syncActiveCompany();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
   
  },
  methods: {
    backCompany() {
      let index = this.findIndex(this.activeCompany.id, 'back')
      if (index < 0) {
        index = this.companies_kind.length - 1
      }
      this.onChild(this.companies_kind[index])
    },
    nextCompany() {
      let index = this.findIndex(this.activeCompany.id, 'next')
      if (index > this.companies_kind.length - 1) {
        index = 0
      }
      this.onChild(this.companies_kind[index])
    },
    findIndex(id, optType) {
      if (!id) {
        return 0
      }
      for (let i = 0; i < this.companies_kind.length; i++) {
        if (this.companies_kind[i].id == id) {
          if (optType == 'next') {
            return i + 1;
          } else {
            return i - 1;
          }
        }
      }
    },
    syncActiveCompany() {
      if (!this.companies_kind.length) {
        this.activeCompany = {};
        return;
      }

      const currentId = this.activeCompany && this.activeCompany.id;
      const activeCompany = currentId
        ? this.companies_kind.find(item => item.id == currentId)
        : null;

      this.activeCompany = activeCompany || this.companies_kind[0];

      this.$nextTick(() => {
        if (this.$refs.Bmap && this.activeCompany && this.activeCompany.lng && this.activeCompany.lat) {
          this.$refs.Bmap.mapFly(this.activeCompany);
        }
      });
    },
    onChild(data) {
      this.activeCompany = data;
      this.$forceUpdate();
      this.$refs.Bmap.mapFly(data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style.css";

.main {
  margin-top: 60px;
  z-index: 9999;

  >div {
    width: 100%;
    background-size: cover;
  }
}



.subsidiary {
  position: relative;
  height: 919px;
  background: url(../../assets/img/classic/map_bg.jpg) no-repeat center;

  .topTitle {
    color: #024094;
    padding-top: 20px;
    text-align: center;
  }

  .flexCenter {
    width: 1600px;
    margin: 0 auto;

    .map {
      display: flex;
      position: relative;

      .mabs {
        width: 100%;
      }

      .detail {
        width: 20vw;
        padding: 10px 80px 20px;
        text-align: left;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background-color: #fff;
        border-radius: 0 0 20px 0;
        box-shadow: 4px 4px 10px rgba(118, 92, 92, 0.2);

        >div {
          line-height: 34px;
          font-size: 19px;
          font-family: Source Han Sans CN;
          color: #333333;
        }

        .comName {
          font-size: 21px;
          font-weight: bold;
          line-height: 54px;
        }

        img {
          width: 12px;
          margin-right: 5px;
        }

        a {
          color: #333333;
        }

        .btns {
          width: calc(100% - 20px);
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);

          img {
            width: 40px;
            cursor: pointer;
          }
        }
      }
    }

    .contain {
      position: absolute;
      left: 1000px;
      top: 620px;

      img {
        width: 123px;
      }
    }

    .companies {
      .nameList {
        // background-color: #fff;
        display: flex;
        flex-wrap: wrap;

        // justify-content: space-around;
        .type {
          width: auto;
          min-width: 90px;
          text-align: left;
          font-size: 16px;
          color: #333333;
          line-height: 44px;
          font-weight: 600;
          margin-left: 20px;

          &::after {
            content: ":";
          }
        }

        .item {
          text-align: left;
          font-size: 21px;
          color: #333333;
          line-height: 40px;
          min-width: 132px;
          text-align: center;
          cursor: pointer;
          margin: 10px 20px;
          width: 137px;
          background-size: 100% 100%;
          border: 1px solid #e4e7ed;
          border-radius: 6px;
          background-color: #fff;
          z-index: 999;
        }

        .longwidth {
          width: 132px;
        }

        .shortwidth {
          width: 90px;
        }

        .active {
          border: none;
          background-image: url(../../assets/img/fzgsxz.png)
        }
      }
    }
  }
}
</style>
